import ThankYouView from './view';
import ThankYouModal, { THANK_YOU_MODAL } from './modal';

export { ThankYouModal, THANK_YOU_MODAL };
export default ThankYouView;
